import { defineRouting } from "next-intl/routing";

/**
 * The UI locales this app ships message catalogs for (see `messages/`).
 *
 * This is the *app*-level set, deliberately static: middleware runs on the Edge
 * before we know which tenant (let alone which project) a request belongs to, so
 * it can only negotiate against a fixed list. Which of these a given tenant
 * actually publishes is a runtime question — see `tenantLocales` in lib/tenant.ts.
 */
export const locales = ["en", "fr"] as const;

export type AppLocale = (typeof locales)[number];

export const routing = defineRouting({
  locales,
  defaultLocale: "en",
  localeDetection: false,
  // No `NEXT_LOCALE` cookie. next-intl sets one by default, independently of
  // `localeDetection`, and nothing here reads it: the locale is in the path. It
  // is not free, though — the edge cache in front of the cluster refuses to
  // store any response to a request carrying a cookie, so one inert cookie on
  // the first page view would make every later media and tile request
  // uncacheable for that visitor.
  localeCookie: false,
});
